// src/config/runtime.js
// Runtime split for normal web browser builds and Electron shell builds.
// Default is web so localhost/domain tests never reserve Electron title-bar space.

export const APP_RUNTIME_WEB = 'web';
export const APP_RUNTIME_ELECTRON = 'electron';
export const ELECTRON_TITLE_BAR_HEIGHT = 40;

function readRuntimeFromEnv() {
  const envRuntime =
    typeof process !== 'undefined'
      ? process.env?.REACT_APP_RUNTIME
      : '';

  const globalRuntime =
    typeof window !== 'undefined'
      ? window.__NPC_RUNTIME__ || window.__APP_RUNTIME__
      : '';

  return String(envRuntime || globalRuntime || APP_RUNTIME_WEB)
    .trim()
    .toLowerCase();
}

export function getAppRuntime() {
  const runtime = readRuntimeFromEnv();
  return runtime === APP_RUNTIME_ELECTRON ? APP_RUNTIME_ELECTRON : APP_RUNTIME_WEB;
}

export function isElectronRuntime() {
  return getAppRuntime() === APP_RUNTIME_ELECTRON;
}

export function hasElectronShell() {
  if (typeof window === 'undefined') return false;
  return Boolean(window.npcShell?.isElectron);
}

export function shouldUseElectronChrome() {
  // Electron UI chrome is enabled only when both conditions are true:
  // 1) this React build/runtime is explicitly marked as electron
  // 2) Electron preload actually exposed window.npcShell.isElectron
  return isElectronRuntime() && hasElectronShell();
}

export function getElectronTitleBarHeight() {
  return shouldUseElectronChrome() ? ELECTRON_TITLE_BAR_HEIGHT : 0;
}
